import type { AppOnboard } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PatchModel } from "@shared/models/patch"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

interface Payload {
  planbookId: string
}

export default function preparePlanbookCompleteOnboarding(payload: Payload): PreparedAction {
  return {
    name: "PLANBOOK_COMPLETE_ONBOARDING",
    payload: payload,
    patches: patches(payload),
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

const patches = function (payload: Payload): Array<PatchModel> {
  let patch = Patch.create("planbook", payload.planbookId).set(
    `attributes.flags.hasNotFinishedOnboarding`,
    false
  ).patch
  return [patch]
}

const narrative = function (payload: Payload, findFn: FindFn, userId: string): Narrative | null {
  let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)
  let newEvent: AppOnboard = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "planbook_onboarding",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com", payload.planbookId],

    adverbial_verb: "navigating",

    adverbial_object_type: "screen",
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com", payload.planbookId],
  }

  return {
    title: `Planbook - Complete Onboarding`,
    titleForAnalytics: "Planbook - Onboarding Complete",
    description: `Completed onboarding`,
    context: defaultPlanbookContext(payload, models),
    activity: defaultPlanbookActivity(payload, models),
    newAnalyticsEvents: [newEvent],
  }
}
